export function isDefined<T>(obj: T | undefined): T {
	if (obj === undefined) {
		throw new Error("Object is undefined.");
	}
	return obj;
}

export function isNonNull<T>(obj: T | null): T {
	if (obj === null) {
		throw new Error("Object is null.");
	}
	return obj;
}

export function identity<T>(value: T): T {
	return value;
}

export function select<T>(predicate: boolean, when: (() => T) | T, otherwise: (() => T) | T): T {
	if (predicate) {
		return typeof when === "function" ? (when as () => T)() : when;
	} else {
		return typeof otherwise === "function" ? (otherwise as () => T)() : otherwise;
	}
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function catchTyped<T>(t: { new (): T }, reason: any): Promise<T> {
	if (reason instanceof t) {
		return Promise.resolve(reason);
	} else {
		return Promise.reject(reason);
	}
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function ensure<T>(val: any, type: { new (...args: any): T }): T {
	if (!(val instanceof type)) {
		throw new Error("Expected current binding context to be of type '" + type + "'.");
	}
	return <T>val;
}
